module.exports = __webpack_public_path__ + "img/loading.8fd6aad4.gif";